export default __webpack_public_path__ + "static/media/lucedelmare3.221b3140.jpg";